var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vbg-ff-root-container"},[(this.whichRealm)?_c('Header'):_vm._e(),_c('div',{staticClass:"vbg-ff-content-container"},[_c('ErrorMessage',{attrs:{"title":_vm.title,"description":_vm.des}})],1),(this.whichRealm)?_c('Footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }